import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./PendingDeletionRequest.module.css";
import pendingDeletionRequestWhite from "../../assets/images/pending-deletion-request-white.svg";
let order = "desc";

var products = [
  {
    id: 1,
    name: "John Doe",
    price: "09:30 PM"
  },
  {
    id: 2,
    name: "Sarah P",
    price: "09:30 PM"
  },
  {
    id: 2,
    name: "Malcolm X",
    price: "09:30 PM"
  }
];

export class PendingDeletionRequest extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleBtnClick = () => {
    if (order === "desc") {
      this.refs.table.handleSort("asc", "name");
      order = "asc";
    } else {
      this.refs.table.handleSort("desc", "name");
      order = "desc";
    }
  };

  render() {
    return (
      <div>
        <div className={`card ${style.todayAppCard}`}>
          <div className={`card-header ${style.todayAppHeader}`}>
            <div className="d-flex align-items-center">
              <img
                src={pendingDeletionRequestWhite}
                alt="Pending Deletion Request"
              />
              Pending Deletion Request
            </div>
            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
          </div>
          <div className="card-body dashboard-time-table-wrapper">
            <BootstrapTable ref="table" data={products} version="4">
              <TableHeaderColumn
                dataField="name"
                isKey={true}
                // dataSort={true}
                width={"65%"}
              >
                Entry Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="price"
                // dataSort={true}
                width={"35%"}
              >
                Time
              </TableHeaderColumn>
            </BootstrapTable>
            <div className={style.fotterDotsWrapper}>
              <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PendingDeletionRequest;
